import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortFileName'
})
export class ShortFileNamePipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if ((value?.length || 0) > 110) {
      return value.substr(0, 107) + '...';
    }
    return value;
  }
}
